var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"danger","disabled":_vm.loading},on:{"click":function($event){_vm.$emit('signIn')}}},[_c('font-awesome-icon',{attrs:{"icon":['fab', 'google']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }